import React from 'react';
import { Button } from 'primereact/button';
import NotificationBadgeAtom from '../../atoms/NotificationBadge/NotificationBadgeAtom';
import './NotificationHeaderMolecule.scss';

export interface NotificationHeaderMoleculeProps {
  title?: string;
  unreadCount: number;
  onMarkAllRead?: () => void;
  onOpenSettings?: () => void;
  className?: string;
}

/**
 * NotificationHeaderMolecule - Header for notification feed
 * Based on sphere-chat-header design pattern
 */
const NotificationHeaderMolecule: React.FC<NotificationHeaderMoleculeProps> = ({
  title = 'Notifications',
  unreadCount,
  onMarkAllRead,
  onOpenSettings,
  className = ''
}) => {
  return (
    <div className={`notification-header-molecule ${className}`}>
      <div className="notification-header-title-section">
        <h2 className="notification-header-title">{title}</h2>
        {unreadCount > 0 && (
          <NotificationBadgeAtom count={unreadCount} severity="info" />
        )}
      </div>

      <div className="notification-header-actions">
        {unreadCount > 0 && onMarkAllRead && (
          <Button
            label="Mark all as read"
            icon="pi pi-check"
            text
            size="small"
            onClick={onMarkAllRead}
            className="notification-header-mark-all-btn"
          />
        )}

        {onOpenSettings && (
          <Button
            icon="pi pi-cog"
            text
            rounded
            size="small"
            onClick={onOpenSettings}
            className="notification-header-settings-btn"
            aria-label="Notification Settings"
            tooltip="Notification Settings"
            tooltipOptions={{ position: 'left', showDelay: 300 }}
          />
        )}
      </div>
    </div>
  );
};

export default NotificationHeaderMolecule;